import { globalAreaV2Sizes } from '../../global-area-v2/styles';

/**
 * ページレイアウト（メインエリア）固有の値。対応する
 * Component 層のトークンは front-lib にあるが、Component 層は配布されていない（DD 0002 の D1、
 * Deferred）ので変数として参照できず、ここに持つ。Semantic 層に役割がある値は各コンポーネントで
 * `var(--ps-*)` を直接書く。
 */
const pageLayoutV2Sizes = {
  /**
   * メインエリアの幅の下限。`GridD` は DOM の実寸（`clientWidth` / `ResizeObserver`）で列幅を
   * 決めるので、下限が無いと狭い window で列が潰れる。値は ppfw-client の
   * `calcMainAreaWidth()` の下限（`innerWidth < 1180` のときの `850`）をそのまま引き継いだもの。
   * dimension の ramp に無い値なのでここに持つ。
   */
  mainAreaMinWidth: '850px',
} as const;

/**
 * ヘッダーが画面上端から占める高さ。メインエリアに使える縦幅は `calc(100vh - ${chromeHeight})`。
 *
 * ヘッダーの内訳は `global-area-v2` から取る。こちらで持つと、あちらの寸法を変えたときに
 * 黙って食い違う。
 */
const chromeHeight = `calc(${globalAreaV2Sizes.rowHeight} + ${globalAreaV2Sizes.gradientBarHeight})`;

export { chromeHeight, pageLayoutV2Sizes };
